// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Satellites_establishments__3oaBR","header":"Satellites_header__UrALB","tableHeader":"Satellites_tableHeader__3KfzM"};